var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoleto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 23,
    rx: 3.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66968 7H7.82527V17.8252H6.66968V7Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.19064 7H8.54752V17.8252H8.19064V7Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.8598 7H9.50133V17.8252H8.8598V7Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1194 7H10.4784V17.8252H10.1194V7Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6335 7H10.9097V17.8252H10.6335V7Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.79022 7H6.14922V17.8252H5.79022V7Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 7H5.64153V17.8252H5V7Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8236 7H13.9814V17.8252H12.8236V7Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3446 7H14.7036V17.8252H14.3446V7Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0159 7H15.6574V17.8252H15.0159V7Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2756 7H16.6324V17.8252H16.2756V7Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7896 7H17.0658V17.8252H16.7896V7Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9464 7H12.3032V17.8252H11.9464V7Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1561 7H11.7977V17.8252H11.1561V7Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5204 7H18.1598V17.8252H17.5204V7Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7779 7H19.1369V17.8252H18.7779V7Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2941 7H19.5682V17.8252H19.2941V7Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6048 7H20.9638V17.8252H20.6048V7Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8146 7H20.4561V17.8252H19.8146V7Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4396 7H21.7986V17.8252H21.4396V7Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9537 7H22.2299V17.8252H21.9537V7Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2644 7H23.6234V17.8252H23.2644V7Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4742 7H23.1157V17.8252H22.4742V7Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9356 7H25.0912V17.8252H23.9356V7Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4566 7H25.8135V17.8252H25.4566V7Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1258 7H26.7673V17.8252H26.1258V7Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3854 7H27.7444V17.8252H27.3854V7Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8995 7H28.1756V17.8252H27.8995V7Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6302 7H29.2718V17.8252H28.6302V7Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.30853 17.8486H28.4667V11.7817H6.30853V17.8486Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72488 17.617V12.1279H8.78542C9.20389 12.1279 9.53953 12.1832 9.79444 12.2936C10.0472 12.4041 10.2448 12.5761 10.3892 12.8077C10.5337 13.0371 10.6059 13.2793 10.6059 13.5321C10.6059 13.7657 10.5422 13.9867 10.4147 14.1948C10.2873 14.4009 10.0961 14.5687 9.83905 14.6962C10.1704 14.7939 10.4275 14.9596 10.6038 15.1954C10.7822 15.429 10.8714 15.7073 10.8714 16.0259C10.8714 16.283 10.8162 16.523 10.7079 16.7439C10.5995 16.9649 10.4657 17.1348 10.3064 17.2559C10.1471 17.3748 9.94526 17.4662 9.70522 17.5278C9.46305 17.5894 9.16778 17.6191 8.8194 17.6191H6.72488V17.617ZM7.4535 14.4349H8.64097C8.96385 14.4349 9.19327 14.4136 9.33347 14.3711C9.51828 14.3159 9.65849 14.2246 9.75195 14.0971C9.84542 13.9697 9.89215 13.8103 9.89215 13.617C9.89215 13.4343 9.84967 13.2729 9.76045 13.1348C9.67336 12.9946 9.54802 12.899 9.38658 12.8481C9.22514 12.7971 8.94473 12.7716 8.55175 12.7716H7.4535V14.4349ZM7.4535 16.9734H8.82153C9.05732 16.9734 9.22089 16.9649 9.31648 16.9457C9.48217 16.916 9.62237 16.8672 9.73496 16.7971C9.84754 16.727 9.93889 16.625 10.0132 16.4912C10.0855 16.3573 10.1216 16.2023 10.1216 16.0281C10.1216 15.822 10.0685 15.6457 9.96225 15.4928C9.85817 15.3398 9.71159 15.2357 9.52466 15.1741C9.33985 15.1125 9.07007 15.0828 8.72169 15.0828H7.45138V16.9734H7.4535Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5321 15.627C11.5321 14.892 11.736 14.3482 12.146 13.9934C12.488 13.7003 12.9044 13.5537 13.3972 13.5537C13.9431 13.5537 14.3892 13.7321 14.7376 14.0911C15.0839 14.448 15.2581 14.943 15.2581 15.5718C15.2581 16.0837 15.1816 16.4831 15.0286 16.7762C14.8757 17.0694 14.6526 17.2967 14.3574 17.4581C14.0642 17.6195 13.7435 17.7003 13.3972 17.7003C12.8406 17.7003 12.3903 17.5218 12.0462 17.1671C11.7042 16.8102 11.5321 16.2961 11.5321 15.627ZM12.2225 15.6291C12.2225 16.1368 12.333 16.5192 12.556 16.7698C12.779 17.0226 13.0594 17.1501 13.3972 17.1501C13.7328 17.1501 14.0111 17.0226 14.2342 16.7698C14.4572 16.5149 14.5677 16.1283 14.5677 15.6079C14.5677 15.1172 14.4551 14.7454 14.232 14.4948C14.009 14.242 13.7307 14.1145 13.3972 14.1145C13.0594 14.1145 12.779 14.2398 12.556 14.4905C12.333 14.7412 12.2225 15.1214 12.2225 15.6291Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0334 17.617V12.1279H16.7089V17.617H16.0334Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4667 16.328L21.1635 16.4193C21.0551 16.8251 20.8512 17.1395 20.5559 17.3646C20.2585 17.5877 19.8804 17.7003 19.4195 17.7003C18.8395 17.7003 18.3786 17.5218 18.0387 17.1628C17.6988 16.806 17.5289 16.3046 17.5289 15.6589C17.5289 14.9918 17.7009 14.4735 18.0429 14.106C18.3871 13.7364 18.8332 13.5537 19.3812 13.5537C19.9123 13.5537 20.3456 13.7343 20.6813 14.0954C21.0169 14.4565 21.1868 14.9663 21.1868 15.6206C21.1868 15.661 21.1847 15.7205 21.1826 15.7991H18.2193C18.2447 16.2345 18.368 16.5702 18.5889 16.8017C18.8098 17.0332 19.0881 17.1501 19.4173 17.1501C19.6638 17.1501 19.8741 17.0842 20.0482 16.9546C20.2267 16.8229 20.3648 16.6148 20.4667 16.328ZM18.2575 15.2489H20.4731C20.4434 14.9132 20.3584 14.6647 20.2182 14.4969C20.0058 14.2377 19.7254 14.1081 19.3855 14.1081C19.0753 14.1081 18.8162 14.2122 18.6059 14.4183C18.3977 14.6222 18.2809 14.9005 18.2575 15.2489Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M23.481 17.0137L23.5724 17.6085C23.3833 17.6489 23.2134 17.668 23.0647 17.668C22.8204 17.668 22.6313 17.6298 22.4954 17.5512C22.3616 17.4726 22.266 17.3727 22.2107 17.2453C22.1555 17.1178 22.13 16.8523 22.13 16.4487V14.1587H21.6329V13.6383H22.1321V12.6548L22.8076 12.249V13.6383H23.481V14.1587H22.8055V16.489C22.8055 16.6824 22.8161 16.8056 22.8416 16.8608C22.865 16.916 22.9032 16.9585 22.9563 16.9925C23.0095 17.0244 23.0859 17.0414 23.1858 17.0414C23.2601 17.0414 23.36 17.0329 23.481 17.0137Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8931 15.627C23.8931 14.892 24.0971 14.3482 24.507 13.9934C24.849 13.7003 25.2654 13.5537 25.7582 13.5537C26.3042 13.5537 26.7503 13.7321 27.0986 14.0911C27.4449 14.448 27.6191 14.943 27.6191 15.5718C27.6191 16.0837 27.5426 16.4831 27.3897 16.7762C27.2367 17.0694 27.0137 17.2967 26.7184 17.4581C26.4252 17.6195 26.1045 17.7003 25.7582 17.7003C25.2017 17.7003 24.7513 17.5218 24.4072 17.1671C24.0652 16.8102 23.8931 16.2961 23.8931 15.627ZM24.5835 15.6291C24.5835 16.1368 24.694 16.5192 24.917 16.7698C25.1401 17.0226 25.4205 17.1501 25.7582 17.1501C26.0939 17.1501 26.3721 17.0226 26.5952 16.7698C26.8182 16.5149 26.9287 16.1283 26.9287 15.6079C26.9287 15.1172 26.8161 14.7454 26.5931 14.4948C26.37 14.242 26.0917 14.1145 25.7582 14.1145C25.4205 14.1145 25.1401 14.2398 24.917 14.4905C24.694 14.7412 24.5835 15.1214 24.5835 15.6291Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoleto);
export default __webpack_public_path__ + "static/media/boleto.bb5f023501ce35560b843b4b6e8c8179.svg";
export { ForwardRef as ReactComponent };